import React from 'react';
import './tailwind.css';
import { createRoot } from 'react-dom/client';
import ShopStarterApp from './ShopStarterApp';

async function boot() {
  const container = document.getElementById('root');
  const path = String(window.location.pathname || '');
  const invoiceMatch = path.match(/^\/invoice\/([^/]+)\/?$/);

  if (invoiceMatch) {
    const token = invoiceMatch[1];
    if (container) {
      container.innerHTML = '<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;font-family:system-ui,sans-serif;color:#374151">Loading invoice...</div>';
    }
    try {
      const res = await fetch(`/shopapi/public-invoice/${encodeURIComponent(token)}`, {
        credentials: 'include',
        headers: { Accept: 'text/html' }
      });
      const html = await res.text();
      if (!res.ok || !html.trim()) {
        throw new Error('Invoice not found');
      }
      document.open();
      document.write(html);
      document.close();
      return;
    } catch {
      if (container) {
        container.innerHTML = '<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;font-family:system-ui,sans-serif;color:#111827;text-align:center"><div><h1 style="margin:0 0 12px;font-size:28px">Invoice not found</h1><p style="margin:0;color:#6b7280">This invoice link is invalid or has expired.</p></div></div>';
        return;
      }
    }
  }

  if (!container) return;
  const root = createRoot(container);
  root.render(<ShopStarterApp />);
}

boot();
